import React from 'react'

const AEC = () => {
  return (
    <div>AEC</div>
  )
}

export default AEC